import { useQuery } from "@tanstack/react-query";
import { Space } from "antd";
import { externalWebhookColumns } from "./lib/constants/externalWebhookColumns";
import { Link } from "react-router-dom";
import { fetchExternalWebhooks } from "@/lib/api/resources/externalWebhooks";
import { Table } from "@/components/v2";
import { Button } from "@rumbledirect/ui";
import { PlusOutlined } from "@ant-design/icons";

export const ExternalWebhooksList = () => {
  const externalWebhooksQuery = useQuery({
    queryKey: ["ExternalWebhooks"],
    queryFn: fetchExternalWebhooks,
  });

  return (
    <div>
      <Space
        style={{ marginBottom: 16, width: "100%", justifyContent: "flex-end" }}
      >
        <Link to="/external-webhooks/create">
          <Button icon={<PlusOutlined />}>Nieuwe externe webhook</Button>
        </Link>
      </Space>
      <Table
        columns={externalWebhookColumns}
        dataSource={externalWebhooksQuery.data?.member}
        loading={externalWebhooksQuery.isLoading}
        pagination={false}
      />
    </div>
  );
};
